<template>
    <div
        v-if="isBannerVisible"
        role="region"
        aria-label="Cookie consent"
        data-testid="cookie-consent-banner"
        class="fixed inset-x-0 bottom-0 z-40 border-t bg-white py-4 md:py-4">
        <div class="container space-y-2">
            <h3>{{ $t("CookiePolicy.ModalTitle") }}</h3>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="$t('CookiePolicy.ModalDescription')"></div>

            <div class="flex flex-col sm:flex-row gap-2">
                <Button data-testid="cookie-consent-accept-all" v-bind="buttonProps" @click="acceptAll">
                    {{ $t("CookiePolicy.SettingsAcceptAll") }}
                </Button>
                <Button data-testid="cookie-consent-reject" v-bind="buttonProps" @click="acceptEssential">
                    {{ $t("CookiePolicy.SettingsAcceptEssential") }}
                </Button>
                <Button
                    data-testid="cookie-consent-manage-preferences"
                    v-bind="{ ...buttonProps, variant: 'link' }"
                    @click="isDialogVisible = true">
                    {{ $t("CookiePolicy.ManagePreferences") }}
                </Button>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { ButtonVariants } from "../ui";

const { isBannerVisible, isDialogVisible, acceptAll, acceptEssential } = useCookieConsent();

const buttonProps: ButtonVariants = { variant: "primary", size: "sm" };
</script>
